import { Component, Input, Output, EventEmitter } from '@angular/core';

export type AlertVariant = 'success' | 'warning' | 'error' | 'info' | 'secondary';
export type AlertSize = 'small' | 'medium' | 'large';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent {
  @Input() variant: AlertVariant = 'info';
  @Input() size: AlertSize = 'medium';
  @Input() outlined: boolean = false;
  @Input() dismissible: boolean = false;
  @Input() icon?: string;
  @Input() showIcon: boolean = true;
  @Input() title?: string;
  @Input() message?: string;

  @Output() dismissed = new EventEmitter<void>();

  isVisible = true;

  onDismiss(): void {
    this.isVisible = false;
    this.dismissed.emit();
  }

  get alertClasses(): string {
    const classes = [
      `alert-${this.variant}`,
      `alert-${this.size}`,
    ];
    if (this.outlined) classes.push('alert-outlined');
    if (this.dismissible) classes.push('alert-dismissible');
    return classes.join(' ');
  }

  get defaultIcon(): string {
    const icons: Record<AlertVariant, string> = {
      success: 'check_circle',
      warning: 'warning',
      error: 'error',
      info: 'info',
      secondary: ''
    };
    return icons[this.variant];
  }

  get displayIcon(): string | null {
    if (this.icon) return this.icon;
    if (this.showIcon) return this.defaultIcon;
    return null;
  }
}
